import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";

const DETAILS = [
  {
    tag: "Material",
    title: "Stone, quarried slowly.",
    sub: "Honed marble, soft-vein quartzite, end-grain timber — never compromised.",
    img: "https://images.pexels.com/photos/10486222/pexels-photo-10486222.jpeg?auto=compress&cs=tinysrgb&w=2000",
  },
  {
    tag: "Precision",
    title: "Tolerances measured in tenths.",
    sub: "Doors that close like a luxury car. Drawers that whisper. No misalignment.",
    img: "https://images.unsplash.com/photo-1556912173-3bb406ef7e77?auto=format&fit=crop&w=2000&q=80",
  },
  {
    tag: "Hardware",
    title: "Brushed brass. Solid weight.",
    sub: "Hardware you reach for ten times a day. Made to feel right in the hand.",
    img: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=2000&q=80",
  },
  {
    tag: "Finish",
    title: "Finishes built to last.",
    sub: "Premium two-pack lacquer, natural stone seals and timber veneers — finished to a standard that still looks new a decade in.",
    img: "https://images.pexels.com/photos/37030080/pexels-photo-37030080.jpeg?auto=compress&cs=tinysrgb&w=2000",
  },
];

export default function Craftsmanship() {
  return (
    <section
      id="craft"
      data-testid={TID.craftsmanship.root}
      className="relative bg-sand py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <p className="text-[11px] md:text-[12px] tracking-[0.32em] uppercase text-ink mb-10">
          Chapter Two — Craft
        </p>
        <div className="grid md:grid-cols-12 gap-12">
          <h2 className="md:col-span-7 font-display font-light text-[10vw] md:text-[5.6vw] leading-[0.98] tracking-tightest text-charcoal">
            A kitchen is the sum of a thousand small decisions.
          </h2>
          <p className="md:col-span-4 md:col-start-9 text-ink text-lg md:text-xl leading-relaxed self-end">
            We make all of them. Not most. All.
          </p>
        </div>
      </div>

      <div className="mt-24 md:mt-32 space-y-28 md:space-y-44">
        {DETAILS.map((d, i) => (
          <div
            key={d.tag}
            data-testid={TID.craftsmanship.item}
            className={`mx-auto max-w-[1400px] px-6 md:px-12 grid md:grid-cols-12 gap-10 items-end ${
              i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""
            }`}
          >
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
              className="md:col-span-8 relative overflow-hidden"
            >
              <img
                src={d.img}
                alt={d.title}
                className="w-full h-[60vh] md:h-[78vh] object-cover transition-transform duration-[1200ms] hover:scale-[1.04]"
              />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, delay: 0.15 }}
              className="md:col-span-4"
            >
              <span className="text-[11px] tracking-[0.32em] uppercase text-brassDark">
                {d.tag}
              </span>
              <h3 className="mt-5 font-display text-3xl md:text-4xl text-charcoal leading-tight">
                {d.title}
              </h3>
              <p className="mt-5 text-ink leading-relaxed">{d.sub}</p>
            </motion.div>
          </div>
        ))}
      </div>
    </section>
  );
}
